/* Mega panel v7 (sections/szw-header.liquid, 2026-10-03).
   Opens on hover (with a short delay so a mouse crossing the bar does not flash it), on keyboard focus,
   and on click / tap: the first click on "Collections" opens the panel, a second click follows the link.
   Esc, a click outside, or scrolling the page closes it. While it is open the header section carries
   .is-mega-open, so the bar turns solid over the hero (szw-mega.css). */
(function () {
  'use strict';
  var items = document.querySelectorAll('[data-szw-mm-item]');
  if (!items.length) return;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  Array.prototype.forEach.call(items, function (item) {
    var trigger = item.querySelector('[data-szw-mm-trigger]');
    var panel = item.querySelector('[data-szw-mm]');
    var section = item.closest('.szw-header-section');
    if (!trigger || !panel) return;
    var openTimer = 0, closeTimer = 0, quietFocus = false, openedAtY = 0;

    function isOpen() { return item.classList.contains('is-open'); }
    function set(open) {
      clearTimeout(openTimer); clearTimeout(closeTimer);
      if (open === isOpen()) return;
      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (section) section.classList.toggle('is-mega-open', open);
      if (open) openedAtY = window.scrollY;
    }

    // hover (mouse only; touch screens get the click behaviour below)
    item.addEventListener('mouseenter', function () {
      if (!finePointer.matches) return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () { set(true); }, 90);
    });
    item.addEventListener('mouseleave', function () {
      if (!finePointer.matches) return;
      clearTimeout(openTimer);
      // keep it open while the keyboard is inside it
      if (item.contains(document.activeElement) && document.activeElement !== trigger) return;
      closeTimer = setTimeout(function () { set(false); }, 220);
    });

    // click / tap: first one opens, second one goes to the page
    trigger.addEventListener('click', function (e) {
      if (!isOpen()) { e.preventDefault(); set(true); }
    });

    // keyboard: focusing the trigger opens; Tab walks into the panel; ArrowDown jumps to its first link
    trigger.addEventListener('focus', function () {
      if (quietFocus) { quietFocus = false; return; }
      if (trigger.matches(':focus-visible')) set(true);
    });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault(); set(true);
        var first = panel.querySelector('a, button');
        if (first) first.focus();
      }
    });
    item.addEventListener('focusout', function (e) {
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      if (finePointer.matches && item.matches(':hover')) return;
      set(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen()) return;
      var inside = item.contains(document.activeElement);
      set(false);
      if (inside) { quietFocus = true; trigger.focus(); }
    });
    document.addEventListener('pointerdown', function (e) {
      if (isOpen() && !item.contains(e.target)) set(false);
    });
    window.addEventListener('scroll', function () {
      if (isOpen() && Math.abs(window.scrollY - openedAtY) > 120) set(false);
    }, { passive: true });

    // "Search by SKU": close the panel and put the cursor in the header search
    var sku = panel.querySelector('[data-szw-mm-sku]');
    if (sku) sku.addEventListener('click', function () {
      set(false);
      var field = document.getElementById('SzwHeaderSearch');
      if (field && !field.offsetParent) {
        var toggle = document.querySelector('[data-szw-search-toggle]');
        if (toggle) toggle.click();
      }
      if (field) setTimeout(function () { field.focus(); }, 60);
    });
  });
})();
